import messages from "messages";
import { Button, ButtonProps, Spinner } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./TimeslotCancelSessionButton.module.scss";

type Props = {
  busy?: boolean;
  disabled?: boolean;
  title?: string | boolean;
  className?: string;
  inModal?: boolean;
} & Pick<ButtonProps, "onClick" | "size">;

const TimeslotCancelSessionButton = ({
  busy,
  title,
  className = "",
  inModal,
  ...rest
}: Props) => (
  <Button
    variant="outline-primary"
    size={"sm"}
    className={getClasses(
      styles["timeslot-cancel-session-button"],
      inModal && styles["timeslot-cancel-session-button--modal"],
      className,
    )}
    {...rest}
  >
    {busy ? (
      <>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className={"mr-1"}
        />
        {messages.loading}
      </>
    ) : (
      title || messages.cancelSession
    )}
  </Button>
);

export default TimeslotCancelSessionButton;
